"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBunkBed = function SvgBunkBed(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6v16m0-9.499h4",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 8.5h19V6.534H2.497V1.498a.998.998 0 0 0-1.997 0V8.5z",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.196 6.337c.466-.467.159-2.03-.797-2.986-.917-.916-2.04-1.06-2.551-.55-.518.519-.378 1.716.532 2.627.99.99 2.383 1.342 2.816.91zm0 10c.466-.467.159-2.03-.797-2.986-.917-.917-2.021-1.06-2.531-.55-.524.524-.394 1.72.512 2.627.99.99 2.383 1.342 2.816.91z",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 18.5h19v-1.966H2.497v-5.036a.998.998 0 1 0-1.997 0V18.5z",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    fill: "#D8D8D8",
    d: "M.5 9.5h1v10h-1z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: 15.5,
    cy: 3.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: 19.5,
    cy: 3.5,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 6v16M17 14.5h4m-4 2h4",
    stroke: "#4D4D4D"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBunkBed);
var _default = exports["default"] = Memo;